/**
 * 加载招行SDK
 */
import loadAsset from 'loadAsset'
import moment from 'moment'
import ua from 'ua'
import { stringify, append } from 'qs'

function loadZHStatistic () {
  let urlTD = ua.isProduct ? 'https://static.cc.cmbimg.com/s/cmb-statistics/1.0.0/cmb-statistics.min.js' : 'https://try.cdcc.cmbchina.com/Static/cmb-statistics/1.0.0/cmb-statistics.min.js'
  let url = ua.isProduct() ? 'https://static.cc.cmbimg.com/s/cmb-statistics/2.0.0/cmb-statistics.min.js' : 'https://try.cdcc.cmbchina.com/Static/cmb-statistics/2.0.0/cmb-statistics.min.js'

  if (window.cmbStatistics === undefined) {
    return loadAsset(`${urlTD}?v=${moment().format('MM-DD')}`)
      .then(() => {
        return loadAsset(`${url}?v=${moment().format('MM-DD')}`)
      })
  }

  return new Promise((resolve) => {
    resolve()
  })
}

export function loadZHSDK () {
  let url = ua.isProduct() ? 'https://assets.piaoniu.com/cmblifeSDK.js' : 'https://assets.piaoniu.com/cmblifeSDK-Dev.js'
  if (window.cmblife === undefined) {
    return loadAsset(`${url}?v=${moment().format('MM-DD')}`)
  }

  return new Promise((resolve) => {
    resolve()
  })
}

export function statisticsPageTD (key, value) {
  if (ua.isFromZhaohang()) {
    loadZHStatistic().then(() => {
      console.log('statisticsPageTD', key)
      window.cmbStatistics && window.cmbStatistics.onEvent(key)
    })
  }
}

export function statisticsPage (key, value) {
  if (ua.isFromZhaohang()) {
    console.log('statisticsPage')
    loadZHStatistic().then(() => {
      window.cmbStatistics && window.cmbStatistics.instance().onEvent('moviePage', {
        pageName: key
      })
    })
  }
}

export function zhaohangGo (url) {
  if (ua.isFromZhaohang()) {
    let loadZHSDK = require('zhaohangSdk').loadZHSDK
    loadZHSDK().then(() => {
      if (window.cmblife) {
        let cmbUrl = `cmblife://go?url=web&version=v2&next=${encodeURIComponent(url)}`
        window.cmblife.executeProtocol(cmbUrl)
      }
    }).catch((err) => {
      console.log(err.toString())
    })
  }
}

export function zhanghangShare (params) {
  let pathname = location.pathname
  if (pathname.indexOf('/campaign') === 0) {
    params.desc = '打折演出票 | 演唱会 展览 话剧 赛事'
  }
  if (pathname === '/applying/detail.html') {
    params.desc = '演出免费报名 | 0元抽奖'
  }
  if (/\/activity\/\d+/.test(pathname)) {
    params.desc = '我推荐这个演出'
  }

  window.share = () => {
    if (ua.isFromZhaohang()) {
      let config = {
        title: params.title.replace(/票牛/g, ''),
        content: params.desc,
        shareType: 'normal',
        picurl: params.imgUrl || require('../ui/img/cmbLogo.jpeg'),
        url: append(params.link, {
          cmblife: 1
        })
      }
      let shareProtocol = `cmblife://share?${stringify(config)}`
      window.location.href = shareProtocol
    }
  }
}




// WEBPACK FOOTER //
// ./src/mods/zhaohangSdk.js